<!--
 * @Author: zxf
 * @Date: 2023-07-03 18:15:59
 * @LastEditors: zxf
 * @LastEditTime: 2023-07-04 15:41:02
 * @Description: file content
-->
<template>
  <el-button
    v-if="authType && capacityEffect"
    v-bind="$attrs"
    v-on="$listeners"
  >
    {{ btnText }}
  </el-button>
  <el-button
    v-else-if="!authType"
    v-bind="$attrs"
    v-on="$listeners"
  >
    {{ btnText }}
  </el-button>
  <span
    v-else-if="showText !== ''"
    class="u-text-info"
  > {{ showText }} </span>
</template>

<script>
export default {
  name: 'KButton',
  props: {
    btnText: {
      type: String,
      default: ''
    },
    authType: {
      type: Boolean,
      default: false
    },
    showText: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      capacityEffect: false // 身份有效
    };
  },
  methods: {
  },
  created () {
    const currentUser = this.$HMStoreService.getUserinfo();
    this.capacityEffect = currentUser.capacityEffect;
  }
};
</script>
